import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const ReferenceCheckingHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Reference Checking
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Streamline your reference checking process with automated tools and templates.
          Gather valuable insights about candidates from their previous employers and colleagues.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Reference Request Templates
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Create and customize reference request templates for different roles and levels.
          Ensure consistent and professional communication with references.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Automated Reference Collection
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Automate the reference collection process with email requests and online forms.
          Track reference responses and follow up automatically when needed.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Reference Questionnaires
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Design custom reference questionnaires to gather specific information about
          candidates' skills, work ethic, and cultural fit.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Reference Verification
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Verify reference information and track the status of reference checks.
          Maintain a complete record of reference feedback for each candidate.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/tools/reference-checking"
            color="primary"
            variant="contained"
          >
            Configure Reference Checking
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default ReferenceCheckingHelp; 